<template>
  <div class="super-node">
    <div class="asset-summary">
      <!-- 资产概览 -->
      <dna-asset-summary class="asset-summary"></dna-asset-summary>
    </div>
    <div class="supernode-tabs" v-if="tab!='register'">
      <dna-nav-second
        ref="nav"
        @navSecondHandle="navSecondHandle"
        :currIndex="currIndex"
        :dataSource="[{
        text:$t('superNode.configuration'),
        value:'config'
      },{
        text:$t('superNode.data'),
        value:'data'
      }]"
      ></dna-nav-second>
    </div>
    <div class="super-node-content">
      <dna-wrapper>
        <div class="repre-wrapper">
          <dna-node-repre
            class="rep"
            :nodeNum="superNodeNum"
            :nodeHiNum="bestNodeRate"
            :nodeHiName="bestNodeName"
            :nodeLoNum="worstNodeRate"
            :nodeLoName="worstNodeName"
            :isNodeInfoLoading="isRepresentLeftLoading"
            :isChartLoading="isVoteDataLoading"
            :chartDataList="nodeRatioData"
          ></dna-node-repre>
        </div>
        <div class="round-wrapper">
          <dna-super-node-round></dna-super-node-round>
        </div>

        <div class="register-wrapper" v-if="tab=='register'">
          <dna-super-node-register @onRegisterSuccess="onRegisterSuccess"></dna-super-node-register>
        </div>

        <div class="conf-wrapper" v-if="tab=='config'">
          <dna-super-node-state></dna-super-node-state>
        </div>
        <div class="data-wrapper" v-if="tab=='data'">
          <dna-super-node-vote-history></dna-super-node-vote-history>
        </div>
      </dna-wrapper>
    </div>
    <dna-spin v-if="isGlobalLoading"></dna-spin>
  </div>
</template>

<script>
import dnaAssetSummary from "@/components/AssetSummary/AssetSummary.vue";
import dnaNavSecond from "@/components/NavSecond/NavSecond.vue";
import dnaNodeRepre from "@/components/NodeRepresentation/NodeRepresentation.vue";
import dnaSuperNodeRound from "@/components/SuperNodeRound/SuperNodeRound.vue";
import dnaSuperNodeRegister from "@/components/SuperNodeRegister/SuperNodeRegister.vue";
import dnaSuperNodeState from "@/components/SuperNodeState/SuperNodeState.vue";
import dnaSuperNodeVoteHistory from "@/components/SuperNodeVoteHistory/SuperNodeVoteHistory.vue";
import wsSubscribe from "@/req/wsSubscribe.js";
import UTIL from "@/util/util.js";
import req from "@/req/req.js";
export default {
  data() {
    return {
      isGlobalLoading: true,
      tab: "", //register/config/data
      currIndex: 0,
      superNodeNum: "-",
      bestNodeName: "-",
      bestNodeRate: "-",
      worstNodeName: "-",
      worstNodeRate: "-",
      isRepresentLeftLoading: true,
      isRepresentRightLoading: true,
      nodeRatioData: [],
      isVoteDataLoading: true
    };
  },
  async mounted() {
    let that = this;
    try {
      if (!that.address) {
        that.$router.push("/").catch(err => {});
        return;
      }
      await that.showTab();
      that.isGlobalLoading = false;
      await that.load();
    } catch (err) {
      console.log(err);
      that.isGlobalLoading = false;
      that.$Message.error({
        background: true,
        duration: 5,
        content: that.$t("global.networkError")
      });
    }
  },
  methods: {
    async showTab() {
      let that = this;
      that.tab = that.$route.params.tab;
      that.$refs.nav && that.$refs.nav.setActive(that.tab == "config" ? 0 : 1);
      //获取是不是超级节点
      let isSuperNode = await that.isSuperNode();
      if (isSuperNode) {
        if (that.tab != "config" && that.tab != "data") {
          that.tab = "config";
        }
      } else {
        if (that.tab != "register") {
          that.tab = "register";
        }
      }
      that.$refs.nav && that.$refs.nav.setActive(that.tab == "config" ? 0 : 1);
      that.$router
        .replace({
          name: "supernode",
          params: { tab: that.tab }
        })
        .catch(data => {});
      // that.$route.replace({
      //   path: that.$route.path,
      //   params: { tab: that.tab }
      // });
      //console.log("tab:" + that.tab);
      return true;
    },
    async load() {
      let infoData = await req.fetchAllNodeInfo();
      this.onInfoGet(
        infoData.supernodes_num,
        infoData.best_node,
        infoData.worst_node
      );
      await this.getData();
    },

    // 获取数据
    async getData() {
      this.isVoteDataLoading = true;
      let currentRound = await this.getCurrentRound();
      let data = await req.fetchVoteInfo(currentRound, 1, 15, true);
      // 封装超级节点表格数据
      // 对超级节点数据进行计算和组装
      let totalSuperVote = 0;
      let tempList = [];

      data.cur_vote_num = data.cur_vote_num || 1;

      let accountIds = data.nodes.map(it => it.account_name);
      accountIds = accountIds.filter(it => it); //去空
      accountIds = [...new Set(accountIds)]; //去重
      let accounts = [];
      if (accountIds.length) {
        accounts = await wsSubscribe.wsFetchBtsGetAccountDetailByList(
          accountIds
        );
      }

      for (let i in data.nodes) {
        if (i > 6) {
          break;
        }
        totalSuperVote += data.nodes[i].votes;
        let temp = {
          name: data.nodes[i].name,
          value: ((data.nodes[i].votes / data.cur_vote_num) * 100).toFixed(2)
        };

        if (!temp.name) {
          let acc = accounts.find(it => it.id == data.nodes[i].account_name);
          if (acc) {
            temp.name = acc.name;
          }
        }
        tempList.push(temp);
      }
      let other = (
        ((data.cur_vote_num - totalSuperVote) / data.cur_vote_num) *
        100
      ).toFixed(2);
      tempList.push({ name: this.$t("vote.other"), value: other });
      this.nodeRatioData = tempList;
      this.isVoteDataLoading = false;
    },

    async getCurrentRound() {
      let blockStatus = await req.fetchBlockStatus();
      return blockStatus && blockStatus.cur_round ? blockStatus.cur_round : 0;
    },
    async isSuperNode() {
      let userInfo = this.$store.state.userInfo;
      let account = userInfo.name || userInfo.address;
      if (!account) {
        return false;
      }
      var wa = await wsSubscribe.wsFetchWitnessByAccount(account);
      //console.log(wa);
      return wa;
    },
    navSecondHandle(item, index) {
      //alert(`item:${JSON.stringify(item)},index:${index}`);
      let that = this;
      that.tab = item.value;
      that.$refs.nav && that.$refs.nav.setActive(that.tab == "config" ? 0 : 1);
      that.$router
        .replace({
          name: "supernode",
          params: { tab: that.tab }
        })
        .catch(data => {});
      //console.log("tab:" + that.tab);
    },
    onRegisterSuccess() {
      let that = this;
      that.tab = "config";
      that.$refs.nav && that.$refs.nav.setActive(that.tab == "config" ? 0 : 1);
      that.$router
        .replace({
          name: "supernode",
          params: { tab: that.tab }
        })
        .catch(data => {});
    },
    onInfoGet(superNodeNum, bestNode, worstNode) {
      this.superNodeNum = superNodeNum;
      this.bestNodeName = bestNode.name;
      this.bestNodeRate = bestNode.stability_rate;
      this.worstNodeName = worstNode.name;
      this.worstNodeRate = worstNode.stability_rate;
      this.isRepresentLeftLoading = false;
    }
  },
  computed: {
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    }
  },
  components: {
    dnaAssetSummary,
    dnaNodeRepre,
    dnaSuperNodeRound,
    dnaSuperNodeRegister,
    dnaNavSecond,
    dnaSuperNodeState,
    dnaSuperNodeVoteHistory
  }
};
</script>

<style lang="less" scoped>
@import url("./SuperNode.less");
</style>